import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { keys } from '@/shared/api/queryKeys';
import { env } from '@/shared/config/env';

interface ServerEvent { kind: string; application_id?: string; job_id?: string }

/** One websocket per session. Every server event invalidates the queries it can affect. */
export function useEvents(enabled: boolean) {
  const qc = useQueryClient();
  useEffect(() => {
    if (!enabled) return;
    let socket: WebSocket | null = null;
    let timer: number | undefined;
    let attempts = 0;
    const connect = () => {
      const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
      socket = new WebSocket(`${proto}://${window.location.host}${env.wsPath}`);
      socket.onmessage = (msg) => {
        const event = JSON.parse(msg.data as string) as ServerEvent;
        if (event.kind === 'ping') return;
        void qc.invalidateQueries({ queryKey: keys.applicationsAll });
        void qc.invalidateQueries({ queryKey: keys.jobs });
        void qc.invalidateQueries({ queryKey: keys.callsAll });
        void qc.invalidateQueries({ queryKey: keys.overviewAll });
      };
      socket.onclose = () => {
        if (attempts < 20) timer = window.setTimeout(connect, Math.min(30_000, 1000 * 2 ** attempts++));
      };
      socket.onopen = () => { attempts = 0; };
    };
    connect();
    return () => { window.clearTimeout(timer); socket?.close(); };
  }, [enabled, qc]);
}
